/* Kardhini product page — brief section 8.
   Gallery switching, PIN delivery estimate and the sticky mobile bar.
   Written to ES5 and guarded throughout so a failure here never blocks
   Add to bag, which works without this file. */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function gallery(root) {
    // Every shot is on the page now, so there is nothing to swap. What is
    // left is bringing the selected variant's own photograph into view:
    // Shopify's variant-selects fires `variant:change` with the variant,
    // and each cell carries its media id.
    var wrap = root.querySelector('[data-k-gallery]');
    if (!wrap) return;

    var shots = wrap.querySelectorAll('.k-pdp__shot');
    var thumbs = root.querySelectorAll('[data-k-thumbs] .k-pdp__thumb');
    var phone = window.matchMedia('(max-width: 749px)');

    function behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }

    // Phones show the gallery as a sideways slider; slide it to a shot.
    function slideTo(i) {
      if (!shots[i]) return;
      wrap.scrollTo({ left: i * wrap.clientWidth, behavior: behavior() });
    }

    function markThumb(i) {
      for (var t = 0; t < thumbs.length; t++) {
        var on = t === i;
        thumbs[t].classList.toggle('is-active', on);
        if (on) thumbs[t].setAttribute('aria-current', 'true');
        else thumbs[t].removeAttribute('aria-current');
      }
      var active = thumbs[i];
      if (active && active.parentNode) {
        var strip = active.parentNode;
        strip.scrollTo({ left: active.offsetLeft - (strip.clientWidth - active.clientWidth) / 2, behavior: behavior() });
      }
    }

    for (var t = 0; t < thumbs.length; t++) {
      thumbs[t].addEventListener('click', function () {
        slideTo(parseInt(this.getAttribute('data-index'), 10) || 0);
      });
    }

    var ticking = false;
    wrap.addEventListener('scroll', function () {
      if (ticking || !phone.matches) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        markThumb(Math.round(wrap.scrollLeft / (wrap.clientWidth || 1)));
      });
    }, { passive: true });

    function focusMedia(mediaId) {
      if (!mediaId) return;
      var cell = wrap.querySelector('[data-media-id="' + mediaId + '"]');
      if (!cell) return;
      if (phone.matches) {
        slideTo(Array.prototype.indexOf.call(shots, cell));
        return;
      }
      cell.scrollIntoView({ behavior: behavior(), block: 'center' });
      cell.classList.add('is-picked');
      window.setTimeout(function () { cell.classList.remove('is-picked'); }, 1400);
    }

    document.addEventListener('variant:change', function (e) {
      var v = e.detail && (e.detail.variant || e.detail);
      if (v && v.featured_media) focusMedia(v.featured_media.id);
    });

    // Dawn's picker updates the hidden input's value *property*, which a
    // MutationObserver on attributes never sees. Listen for the change that
    // bubbles from the radios instead and read the input straight after.
    var input = root.querySelector('.product-variant-id');
    var byVariant = {};
    try {
      var data = root.querySelector('[data-k-variant-media]');
      if (data) byVariant = JSON.parse(data.textContent || '{}');
    } catch (err) {}

    function focusSelected() {
      if (!input) return;
      // Dawn swaps the input during its own re-render, so re-read it.
      var live = root.querySelector('.product-variant-id') || input;
      focusMedia(byVariant[live.value]);
    }

    var picker = root.querySelector('variant-selects, variant-radios, .product-form__input');
    if (picker) {
      picker.addEventListener('change', function () {
        // Let the picker finish writing the variant id first.
        window.setTimeout(focusSelected, 0);
      });
    }
  }

  function quantity(root) {
    var box = root.querySelector('.k-qty');
    if (!box) return;
    var input = box.querySelector('.k-qty__input');
    if (!input) return;

    box.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-k-qty]');
      if (!btn) return;
      var step = parseInt(btn.getAttribute('data-k-qty'), 10) || 0;
      var min = parseInt(input.getAttribute('min'), 10) || 1;
      var maxAttr = input.getAttribute('max');
      var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
      var next = (parseInt(input.value, 10) || min) + step;
      input.value = Math.min(max, Math.max(min, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function pin(root) {
    var box = root.querySelector('[data-k-pin]');
    if (!box) return;
    var input = box.querySelector('[data-k-pin-input]');
    var go = box.querySelector('[data-k-pin-go]');
    var out = box.querySelector('[data-k-pin-out]');
    if (!input || !go || !out) return;

    // An estimate from a prefix list, not a courier lookup. The copy says
    // "usually" for that reason.
    var metro = (out.getAttribute('data-metro-prefixes') || '')
      .split(',')
      .map(function (s) { return s.trim(); })
      .filter(Boolean);

    function check() {
      var value = (input.value || '').replace(/\D/g, '');
      if (!/^[1-9][0-9]{5}$/.test(value)) {
        out.textContent = out.getAttribute('data-invalid') || '';
        out.classList.add('is-bad');
        return;
      }
      var isMetro = metro.indexOf(value.slice(0, 3)) !== -1;
      out.textContent = out.getAttribute(isMetro ? 'data-metro' : 'data-rest') || '';
      out.classList.remove('is-bad');
    }

    go.addEventListener('click', check);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); check(); }
    });
  }

  function sticky(root) {
    var bar = root.querySelector('[data-k-sticky]');
    var form = root.querySelector('[data-k-pdp] .product-form__submit') ||
               document.querySelector('.product-form__submit');
    if (!bar || !form) return;

    // The bar is a proxy for the real button so there is only one code path
    // into the cart.
    var proxy = bar.querySelector('[data-k-sticky-add]');
    if (proxy) {
      proxy.addEventListener('click', function () { form.click(); });
    }

    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(
      function (entries) {
        // Show the bar only once the real button has scrolled away.
        bar.hidden = entries[0].isIntersecting;
      },
      { rootMargin: '0px 0px -40% 0px' }
    );
    io.observe(form);
  }

  function prices(root) {
    var box = root.querySelector('[data-k-price]');
    var data = root.querySelector('[data-k-variant-prices]');
    if (!box || !data) return;
    var byVariant = {};
    try { byVariant = JSON.parse(data.textContent || '{}'); } catch (err) { return; }
    var now = box.querySelector('[data-k-now]');
    var was = box.querySelector('[data-k-was]');

    function update() {
      var input = root.querySelector('.product-variant-id');
      var p = input && byVariant[input.value];
      if (!p) return;
      if (now) now.textContent = p.now;
      if (was) was.textContent = p.was || '';
      box.classList.toggle('is-sale', !!p.was);
      var sticky = document.querySelector('.k-sticky__price');
      if (sticky) sticky.textContent = p.now;
    }

    var picker = root.querySelector('variant-selects, variant-radios, .product-form__input');
    if (picker) picker.addEventListener('change', function () { window.setTimeout(update, 0); });
    document.addEventListener('variant:change', function () { window.setTimeout(update, 0); });
  }

  // Delivery dates and the countdown to the dispatch cut-off, worked out in
  // India time whatever the visitor's own clock says.
  function delivery(root) {
    var card = root.querySelector('[data-k-delivery]');
    if (!card) return;
    var min = parseInt(card.getAttribute('data-min'), 10) || 2;
    var max = Math.max(min, parseInt(card.getAttribute('data-max'), 10) || min);
    var cutoffHour = parseInt(card.getAttribute('data-cutoff'), 10);
    if (isNaN(cutoffHour)) cutoffHour = 14;
    var skipSunday = card.getAttribute('data-skip-sunday') === 'true';
    var datesEl = card.querySelector('[data-k-delivery-dates]');
    var line = card.querySelector('[data-k-countdown]');
    var timer = card.querySelector('[data-k-timer]');
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // A Date whose local fields read as the current time in IST.
    function istNow() {
      var d = new Date();
      return new Date(d.getTime() + (d.getTimezoneOffset() + 330) * 60000);
    }
    function closed(d) { return skipSunday && d.getDay() === 0; }
    function addWorkingDays(d, n) {
      var x = new Date(d.getTime());
      var count = 0;
      while (count < n) {
        x.setDate(x.getDate() + 1);
        if (!closed(x)) count++;
      }
      return x;
    }
    function nextCutoff(now) {
      var c = new Date(now.getTime());
      c.setHours(cutoffHour, 0, 0, 0);
      if (now >= c || closed(c)) {
        do { c.setDate(c.getDate() + 1); } while (closed(c));
      }
      return c;
    }
    function ordinal(n) {
      var s = ['th', 'st', 'nd', 'rd'];
      var v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }
    function fmt(d) { return MONTHS[d.getMonth()] + ' ' + ordinal(d.getDate()); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function render() {
      var now = istNow();
      var cutoff = nextCutoff(now);
      // Orders are processed the day of the cut-off they beat.
      var dispatch = new Date(cutoff.getTime());
      if (datesEl) {
        var from = addWorkingDays(dispatch, min);
        var to = addWorkingDays(dispatch, max);
        datesEl.textContent = min === max ? fmt(from) : fmt(from) + ' - ' + fmt(to);
      }
      if (timer && line) {
        var left = Math.max(0, Math.floor((cutoff - now) / 1000));
        var h = Math.floor(left / 3600);
        var m = Math.floor((left % 3600) / 60);
        timer.textContent = h + 'h ' + pad(m) + 'm ' + pad(left % 60) + 's';
        line.hidden = false;
      }
    }

    render();
    window.setInterval(render, 1000);
  }

  ready(function () {
    var pdp = document.querySelector('[data-k-pdp]');
    if (!pdp) return;
    try { prices(pdp); } catch (e) {}
    try { delivery(pdp); } catch (e) {}
    try { gallery(pdp); } catch (e) {}
    try { quantity(pdp); } catch (e) {}
    try { pin(pdp); } catch (e) {}
    try { sticky(document); } catch (e) {}
  });
})();
